import {connect} from 'react-redux';

import {ContactCardPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {getIsUserVisitor} from '../../../store/data/teammates/teammatesSelectors';
import {
  makeGetContactCardAccount,
  makeGetContactCardIsLoading,
  makeGetContactCardSelectedCard,
} from '../../../store/panels/contacts/contactCard/contactCardPanelSelectors';
import {ContactCardDetails} from './contactCardDetails';

/*
 * Props.
 */

interface ContactCardDetailsContainerProps {
  panelId: ContactCardPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactCardDetailsContainerProps>()(() => ({
  card: makeGetContactCardSelectedCard(),
  account: makeGetContactCardAccount(),
  isLoading: makeGetContactCardIsLoading(),
  isUserVisitor: getIsUserVisitor,
}));

export const ContactCardDetailsContainer = connect(mapStateToProps)(ContactCardDetails);
